import { LayoutDashboard, LogOut, User } from "lucide-react";
import "./sidebar.css";
import React from "react";
import { auth } from "../../utils/firebase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext/AppContext";

export default function Sidebar() {
  const ignoreRoute = ["/", "/login"];
  const navigate = useNavigate();
  const {setUserInfo, user} = useAppContext();
  const handleLogout = () => {
    try {
      auth.signOut();
      navigate("/login");
      setUserInfo({});
    } catch (error) {
      console.error("Logout error:", error.message);
      alert("An error occurred while logging out");
    }
  };

  
  
  const location = useLocation();

  if (!user || ignoreRoute.includes(location.pathname) || !user.email ){
    return null;
  }

  return (
    <aside className="sidebar">
      <h2 className="sidebar-title">Student Menu</h2>
      <ul className="sidebar-list">
        <li>
          <Link to="/dashboard">
            <LayoutDashboard className="sidebar-icon" /> Dashboard
          </Link>
        </li>
        {/* <li>
          <Book className="sidebar-icon" /> Courses
        </li>
        <li>
          <DollarSign className="sidebar-icon" /> Credits
        </li> */}
        <li>
            <Link to="/profile">
                <User className="sidebar-icon" /> Profile
            </Link>
        </li>
        <li onClick={handleLogout}>
          <LogOut className="sidebar-icon" /> Logout
        </li>
      </ul>
    </aside>
  );
}
